export type WeekDay = 'LUNDI' | 'MARDI' | 'MERCREDI' | 'JEUDI' | 'VENDREDI' | 'SAMEDI' | 'DIMANCHE'

export const WEEK_DAYS: WeekDay[] = ['LUNDI', 'MARDI', 'MERCREDI', 'JEUDI', 'VENDREDI', 'SAMEDI', 'DIMANCHE']

export type PeriodType = 'ECOLE' | 'SEMAINE_A' | 'SEMAINE_B' | 'VACANCES' | 'RELAX'

export type TypeProgramme = 'FORMATEUR' | 'ETUDIANT'
